<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    show-default-option
                    :options="form.tipos"
                    :validations="validations.tipoId"
                    label="Tipo"
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    label="Descrição"
                    v-model="model.descricao"
                    :validations="validations.descricao"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.justificar"
                >
                    Justificar
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                tipoId: {},
                descricao: {
                    required: true,
                    max: 100,
                    min: 3,
                },
            }
        },
    },
    created() {

        this.repositories = {
            motivoBaixa: this.getConectaSusRepository('almoxarifado.motivoBaixa')
        }

        this.load()
    },
    data: () => ({
        form: { tipos: [] },
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.motivoBaixa.edit(this.id)
                    .then(({ data }) => {

                        this.form = data.form

                        if (data.model) {

                            this.model = this.clone(data.model)
                            this.model.justificar = this.model.justificar || false
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.motivoBaixa.create()
                    .then(({ data }) => {

                        this.form = data.form

                        if (data.model) {

                            this.model = this.clone(data.model)
                            this.model.justificar = this.model.justificar || false
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.motivoBaixa.update(this.id, this.prepareData())
                        : this.repositories.motivoBaixa.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.model)
        },
    },
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number }
    },
}
</script>